import { Component } from "@opten/compiler/metadata/component";

@Component({ className: "js-fav-export" })
export class FavExportComponent {
	private __container__;

	constructor(private element: HTMLElement) {
		this.element.addEventListener("click", (event) => this.exportPdf(event));
	}

	private exportPdf(event: Event): void {
		const button = event.currentTarget as HTMLElement;
		if (button.tagName !== "A") {
			return;
		}
		const action = button.getAttribute('data-action');

		const cookieValue = this.getCookie("OptionsFav");
		// fetch('/umbraco/surface/sgalternativesurface/GetAlternativePdf?favourites=' + cookieValue, {
		// 	method: 'GET'
		// })
		fetch('/umbraco/surface/sgalternativesurface/GetAlternativePdf', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'accept-language': document.documentElement.lang,
				'X-Requested-With': 'XMLHttpRequest',
			},
			body: 'favourites=' + cookieValue,
			credentials: 'include',
		})
			.then(res => res.blob())
			.then(blob => {
				if (action === "download") {
					const link = document.createElement('a');
					link.href = window.URL.createObjectURL(blob);
					link.download = "Alternativen finden.pdf";
					document.body.append(link);
					link.click();
					link.remove();
					//var doc = window.open(window.URL.createObjectURL(blob), '_blank');
				}else if (action === "print") {
					this.__container__ = document.createElement("iframe");
					this.__container__.onload = this.setPrint;
					this.__container__.style.display = "none";
					this.__container__.contentWindow.open(window.URL.createObjectURL(blob));
					document.body.appendChild(this.__container__);
				}
			});
	}

	private setPrint() {
		this.__container__.contentWindow.addEventListener('onbeforeunload', this.closePrint);
		this.__container__.contentWindow.addEventListener('onafterprint', this.closePrint);
		this.__container__.contentWindow.print();
	}

	private closePrint() {
		document.body.removeChild(this.__container__);
	}

	private getCookie(name: string): string | null {
		const cookies = document.cookie.split("; ");
		const cookie = cookies.find((cookie) => cookie.startsWith(`${name}=`));
		return cookie ? cookie.split("=")[1] : null;
	}
}
